/**
 * Route gate for Billing pages that read finance data (#4189, Nick ruling R1 2026-10-01:
 * finance collections are readable only by people with the Finance module, P4).
 *
 * firestore.rules `hasFinanceModule()` refuses these reads to everyone else; without this gate
 * such a user would open the page and see permission errors. Same predicate as the rules and
 * the server's withModuleAccess: the Owner role, or P4 in enabled modules.
 */
import React from 'react';
import { ModuleAccessRoute, useHasAnyModuleAccess } from './ModuleAccessRoute';

const FINANCE: readonly ['P4'] = ['P4'];

/** True when the signed-in user may read finance data (mirrors firestore.rules hasFinanceModule). */
export function useHasFinanceAccess(): boolean {
  return useHasAnyModuleAccess(FINANCE);
}

/** The P4 case of ModuleAccessRoute, with the finance wording. */
export function FinanceAccessRoute({ children }: { children: React.ReactNode }) {
  return (
    <ModuleAccessRoute
      anyOf={FINANCE}
      title="Finance access required"
      description="This page shows accounts receivable and invoice data, which is limited to people with the Finance module. Ask an owner if you need access."
      testId="finance-no-access"
    >
      {children}
    </ModuleAccessRoute>
  );
}
